import { combineReducers } from "redux";

// Front
import Layout from "./layouts/reducer";

const rootReducer = combineReducers({
    // Public
    Layout
});

export default rootReducer;